import React, { useState } from 'react';

import { passwordAPI } from '../../common/api';

import AuthFormContainer from '../../common/components/auth-form-container';
import BannerMessage from '../../common/components/banner-message';
import DangerString from '../../common/components/danger-string';
import { HiddenInviteCode, HiddenProduct, HiddenRedirect } from '../../common/components/forms';
import IString from '../../common/components/i-string';
import WaitButton from '../../common/components/wait-button';

import { serverToQueryString } from '../../common/util/server-util';
import { translate } from '../../common/i18n/localize';

const FORGOT_PASSWORD = 'forgot_password_screen';
const LINK_SENT = 'link_sent_screen';

function ForgotPassword() {
  const [screen, setScreen] = useState(FORGOT_PASSWORD);
  const [sendingLink, setSendingLink] = useState(false);
  const [email, setEmail] = useState('');
  const [error, setError] = useState();
  const query = serverToQueryString();

  const handleSubmit = (e) => {
    e.preventDefault();
    setSendingLink(true);
    passwordAPI.submitForgotPassword(email).then(() => {
      setSendingLink(false);
      setScreen(LINK_SENT);
    }).catch((e) => {
      setSendingLink(false);
      setError(e.response.data.error);
    });
  };

  return (
    <>
      { error &&
        <BannerMessage type='error' className='marginBelow onPage' onClose={() => setError()}>
          { error }
        </BannerMessage> }

      { screen === FORGOT_PASSWORD &&
        <AuthFormContainer title={<IString stringKey='title' />}>
          <a className='backButton' href={`/login${query}`} aria-label={translate('general.back')} />
          <form onSubmit={handleSubmit}>
            <HiddenInviteCode />
            <HiddenProduct />
            <HiddenRedirect />
            <p><IString stringKey='details' /></p>
            <fieldset className="chunk">
              <input type="email" placeholder={translate('email.placeholder')} value={email} required autoFocus onChange={e => setEmail(e.target.value)} />
            </fieldset>

            <fieldset className='actions noMarginAbove'>
              <WaitButton type='submit' wait={sendingLink}>
                <IString stringKey='resetLink' />
              </WaitButton>
            </fieldset>
          </form>
        </AuthFormContainer> }
      { screen === LINK_SENT &&
        <AuthFormContainer title={<IString stringKey='resetLinkSent.title' />}>
          <a className='backButton' href={`/login${query}`} aria-label={translate('general.back')} />
          <form>
            <p><DangerString stringKey='resetLinkSent.details' placeholders={{ email }} /></p>
          </form>
        </AuthFormContainer> }
    </>
  );
}

export default ForgotPassword;
